import React, { memo } from 'react'
import { connect } from 'react-redux'
import 'react-day-picker/lib/style.css'
import { fromContext } from 'store/selectors'
import DayPicker from './DayPicker'

export default connect(state => ({
  lang: fromContext.getLang(state),
  locale: fromContext.getLocale(state),
}))(memo(DayPicker))
